// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19MdK","rootMobile":"styles_rootMobile__1AKma"};